import { Group, Object3D } from "three";
import IsoBlock from "./IsoBlock";
import animate from "./animate";
import { easeInCubic, easeOutCubic } from "@shared/lib/animation/easing";

export interface IsoCheckmarkOptions {
  color: string,
}

export default class IsoCheckmark {
  group: Group;
  blocks: Array<IsoBlock>;

  constructor (parent: Object3D, options: IsoCheckmarkOptions) {
    this.group = new Group();

    this.blocks = [new IsoBlock(this.group, options), new IsoBlock(this.group, options)];

    parent.add(this.group);
  }

  async animateIn (render: () => void): Promise<void> {
    this.blocks[0].mesh.visible = true;
    this.blocks[1].mesh.visible = false;
    this.blocks[1].x = 5;
    this.blocks[1].z = -1;

    await animate((t) => {
      this.blocks[0].width = 1 + t * 5;

      render();
    }, {
      duration: 750,
      easing: easeInCubic,
    });

    this.blocks[1].zAlign = "end";
    this.blocks[1].mesh.visible = true;

    await animate((t) => {
      this.blocks[1].depth = 1 + t * 9;

      render();
    }, {
      duration: 750,
      easing: easeOutCubic,
    });
  }

  async animateOut (render: () => void): Promise<void> {
    this.blocks[0].mesh.visible = true;
    this.blocks[1].mesh.visible = true;

    this.blocks[0].xAlign = "end";
    this.blocks[0].x = 5;

    await animate((t) => {
      this.blocks[0].width = 6 - t * 5;

      render();
    }, {
      duration: 750,
      easing: easeInCubic,
    });

    this.blocks[0].mesh.visible = false;
    this.blocks[1].zAlign = "start";
    this.blocks[1].z = -10;

    await animate((t) => {
      this.blocks[1].depth = 11 - t * 10;

      render();
    }, {
      duration: 750,
      easing: easeOutCubic,
    });
  }

  dispose () {
    this.group.removeFromParent();
    this.blocks.forEach((block) => block.dispose());
    this.blocks.length = 0;
  }
}
